import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import DisplayHeader from 'scoreboard/components/display-header'
import GenericOverviewInfo from './generic-overview-info'
import PublishSubscribersForm from 'scoreboard/alerts/publish-subscribers-form'
import alertButton from 'scoreboard/alerts/alert-button.hbs'
import alertHelper from 'scoreboard/alerts/alert-helper'
import globals from 'scoreboard/components/globals'
import user from 'scoreboard/components/user'

var GenericOverviewInfoDisplayHeader = DisplayHeader.extend({

	events: _.extend({}, DisplayHeader.prototype.events, {
		// TODO: Remove when V5 is no longer supported. These will be page
		// sections instead of dialogs
		'click .open-alerts': 'onAlerts',
		'click .alerts-tab': 'onAlerts'
	}),

	/**
	 * @property {DomainObject} this.model
	 * @property {Subscription[]} this.model.subscriptions
	 * @param {String} [options.section=this.model.get('section')]
	 * 		If this.model.section does not exist, then this option is required
	 * 		for the alerts dialogs to work properly.
	 */
	initialize: function(options) {
		DisplayHeader.prototype.initialize.apply(this, arguments)
	},

	overviewInfo: function() {
		var model = new this.model.constructor({ id: this.model.id })
		appDisplay.dialog(model.fetch({
			data: {
				calendarPeriodId: globals.periodId,
				relatedItems: true,
				templateInfo: true
			}
		}), function() {
			return new GenericOverviewInfo({ model: model })
		}.bind(this))
	},

	/**
	 * Adds an alert button to the header menu, to style (hide/show etc.)
	 * subclasses may implement `styleAlertButton`
	 */
	renderButtons: function() {
		!user.isStrictViewer() && this._renderSubscriptionButton()
		DisplayHeader.prototype.renderButtons.apply(this, arguments)
	},

	_renderSubscriptionButton() {
		let subs = this.model.get('subscriptions')
		const html = alertButton({ count: _.size(subs) })
		// #23862 #23809 placement of display header buttons
		// use placeholder instead of relative location for insertion
		this.$('.open-alerts').replaceWith(html)
		this.alertButton = this.$('.open-alerts')
		this.styleAlertButton(!_.isEmpty(subs))
	},

	onAlerts: function() {
		const {organizationId, section = this.options.section} = this.model.attributes
		const subscribersForm = new PublishSubscribersForm({
			orgId: organizationId,
			domainId: this.model.id,
			section,
			subscriptions: this.model.get('subscriptions')
		})
		subscribersForm.on('change:subscriptions', subscriptions => {
			this.model.set('subscriptions', subscriptions)
			const count = _.size(this.model.get('subscriptions'))
			this.$('.alert-count').html(count)
			this.styleAlertButton(count > 0)
		})
		appDisplay.dialog(subscribersForm)
	},

	styleAlertButton: function(hasAlerts) {
		if (this.alertButton) {
			const {currentUserSubscribed} = alertHelper.getPublishChangesSubscribers(this.model.get('subscriptions'))
			this.alertButton
				.toggleClass('is-subscribed', !_.isNil(currentUserSubscribed))
				.toggleClass('has-alerts', hasAlerts)
				.find('.alert-count')
				.toggleClass('is-not-displayed', !hasAlerts)
		}
	}

})

export default GenericOverviewInfoDisplayHeader

GenericOverviewInfoDisplayHeader.__filename__ = 'components/overview-info/generic-overview-info-display-header.js'
